// extracted by mini-css-extract-plugin
module.exports = {"defaultTiming":"ease-out","dashboardAnimation":"1s ease-out 1s"};